import script from "./NewPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPassword.vue?vue&type=script&setup=true&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=c556dd2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c556dd2e"]])

export default __exports__